import React from 'react'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

const BleedType = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>Bleed Type</InputLabel>
      <Select
        value={moduleValues?.['Bleed Type'] ?? ''}
        label="Bleed Type"
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Bleed Type']: e.target.value,
          }))
        }
      >
        {['Arterial', 'Venous', 'Capillary'].map((x) => (
          <MenuItem key={x} value={x}>
            {x}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export default BleedType
